webpackJsonp([220735278559955],{

/***/ 2098:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"Weight","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"unit","type":{"kind":"ENUM","name":"WeightUnit","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"value","type":{"kind":"SCALAR","name":"Decimal","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-weight-96d406323950488e9107.js